import * as qStates from "./state/questionStates";
import * as qAssign from "./state/questionAssignment";
import * as qCamera from "./state/questionCamera";
import * as serverState from "./state/serverState";
import * as alertDialog from "./state/alertDialog";

import C from "./constants";
import strings from "./resources/strings";

export const quoteReducer = (state = [], action) => {
    console.debug(strings.getString("action", JSON.stringify(action)));
    
    /*let qs = _.get(state, "questionHistory");
    if (qs) {
        console.debug("BEFORE: " + JSON.stringify(qs));
    }*/

    let result;
    switch (action.type) {
        case C.NEXT_QUESTION:
            result =  qStates.advanceQuestion(state, action);
            break;
        case C.PREVIOUS_QUESTION:
            result =  qStates.previousQuestion(state);
            break;
        case C.CAN_ADVANCE:
            result = qStates.setCanAdvance(state, action.canAdvance);
            break;
        case C.ASSIGN_VALUE:
            result = qAssign.dispatchAssignment(state, action);
            break;
        case C.ASSIGN_FROM_CAMERA:
            result = qAssign.assignFromCamera(state, action.cameraFields, action.cameraResults);
            break;
        case C.ASSIGN_FROM_CAMERA_NEW:
            result = qAssign.assignFromCameraNew(state, action.cameraFields, action.cameraResults);
            break;
        case C.SHOW_CAMERA:
            result = qCamera.showCamera(state);
            break;
        case C.HIDE_CAMERA:
            result = qCamera.hideCamera(state);
            break;
        case C.SHOW_RECORDER:
            result = qCamera.showRecorder(state);
            break;
        case C.HIDE_RECORDER:
            result = qCamera.hideRecorder(state);
            break;
        case C.START_LOADING:
            result = qStates.startLoading(state);
            break;
        case C.STOP_LOADING:
            result = qStates.stopLoading(state);
            break;
        case C.SHOW_DIALOG:
            result = alertDialog.showDialog(state, action.text);
            break;
        case C.HIDE_DIALOG:
            result = alertDialog.hideDialog(state);
            break;
        case C.UPDATE_FILE_UPLOAD_PROGRESS:
            result = qStates.updateFileUploadProgress(state, action);
            break;
        case C.UPDATE_QUESTION_RETRIES:
            result = qStates.updateRetries(state, action.count);
            break;
        case C.CREATE_SVR_RECORD:
            result = serverState.createRecord(state, action);
            break;
        case C.SAVE_RECORD:
            result = serverState.saveRecord(state, action);
            break;
        case C.SAVE_FILEPATH:
            result = serverState.saveFilePath(state, action);
            break;
        case C.INCREMENT_FILE_UPLOAD_COUNTER:
            result = qStates.incrementFileUploadCounter(state);
            break;
        case C.DECREMENT_FILE_UPLOAD_COUNTER:
            result = qStates.decrementFileUploadCounter(state, action);
            break;
        case C.INCREMENT_BACKGROUND_REQUEST_COUNTER:
            result = qStates.incrementBackgroundRequestCounter(state);
            break;
        case C.DECREMENT_BACKGROUND_REQUEST_COUNTER:
            result = qStates.decrementBackgroundRequestCounter(state);
            break;
        case C.DISPLAY_USER_MESSAGE:
            result = qStates.displayUserMessage(state, action);
            break;
        case C.HIDE_USER_MESSAGE:
            result = qStates.hideUserMessage(state);
            break;
        case C.LOAD_QUESTION_SET:
            result = serverState.loadQuestionSet(state, action);
            break;
        case C.INITIALIZE_QUESTION_SET:
            result = serverState.initializeQuestionSet(state);
            break;
        case C.INITIATE_WORKFLOW_SESSION:
            result = serverState.initiateWorkflowSession(state, action);
            break;
        case C.UPDATE_COMPANION_WORKFLOW_SESSION_ID:
            result = serverState.setCompanionWorkflowSessionId(state, action);
            break;
        case C.RESUME_WORKFLOW_SESSION:
            result = serverState.resumeWorkflowSession(state, action);
            break;
        case C.HIDE_RESUME_WORKFLOW_MSG:
            result = serverState.hideResumeWorkflowMessage(state);
            break;
        case C.MARK_MEDIA_AS_TAMPERED:
            result = serverState.markMediaAsTampered(state, action);
            break;
        case C.LOAD_CLIENT_REQUEST:
            result = serverState.loadClientRequest(state, action);
            break;
        case C.LOAD_WORKFLOW_DATA:
            result = serverState.loadWorkflowData(state, action);
            break;
        case C.LOAD_UI_CONFIG:
            result = serverState.loadUIConfig(state, action);
            break;
        case C.CAPTURE_REF_ID:
            result = serverState.saveReferenceId(state, action);
            break;
        case C.CAPTURE_REQUEST_ID:
            result = serverState.saveRequestId(state, action);
            break;
        case C.CAPTURE_ACCESS_CODE:
            result = serverState.saveAccessCode(state, action);
            break;
        case C.CAPTURE_ORGANIZATION:
            result = serverState.saveOrganization(state, action);
            break;
        case C.CAPTURE_USERDATA:
            result = qAssign.assignFromUrlQueryString(state, action);
            break;
        case C.MERGE_ADDITIONAL_QUESTIONS:
            result = qStates.assembleAllQuestions(state);
            break;
        case C.SAVE_LOCATION:
            result = qStates.saveLocationData(state, action);
            break;
        case C.VALUE_FORMAT_ERROR:
            result = qStates.valueFormatError(state, action);
            break;
        case C.RECORD_BILLABLE_OPERATION:
            result = serverState.recordBillableOperation(state, action);
            break;
        case C.STORE_ANALYSIS_RESPONSE:
            result = serverState.storeAnalysisResponse(state, action);
            break;
        case C.UPLOAD_ANSWER_DATA:
            result = qStates.initiateUploadAnswerData(state, action);
            break;
        case C.ADD_BACKGROUND_MEDIA_FUNCS:
            result = qStates.addBackgroundMediaFuncs(state, action);
            break;
        case C.REMOVE_BACKGROUND_MEDIA_FUNCS:
            result = qStates.removeBackgroundMediaFuncs(state, action);
            break;
        case C.STORE_EXTRACTED_RESULT:
            result = qAssign.assignFromExtractedText(state, action);
            break;
        case C.STORE_RESULT_DATA:
            result = serverState.storeResultData(state, action);
            break;
        case C.STORE_MEDIA_FILE_DATA:
            result = serverState.storeMediaFileData(state, action);
            break;
        case C.SUBMITTED_WORKFLOW:
            result = qStates.submittedWorkflow(state);
            break;
        case C.APPEND_MEDIA_FILE_DATA:
            result = serverState.appendMediaFileData(state, action.uuid, action.data);
            break;
        case C.VALIDATE_FIELD:
            return state;
        default:
            console.warn(strings.getString("unknownAction", action));
            result = state;
            break;
    }

    /*qs = _.get(result, "questionHistory");
    if (qs) {
        console.debug("AFTER: " + JSON.stringify(qs));
    }*/

    return result;
};

export const initialState = () => {
    return qStates.initializeState(qStates.state);
};
